import React, { memo, forwardRef } from "react";
const SvgStrictsubset = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M24 23a1 1 0 00-1-1h-7a6 6 0 010-12h7a1 1 0 100-2h-7a8 8 0 100 16h7a1 1 0 001-1z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgStrictsubset.displayName = "SvgStrictsubset";
const MemoForwardRef = memo(SvgStrictsubset);
export default MemoForwardRef;
